<a routerLink="/location/{{id}}" *ngIf="location">{{ location['name'] }}</a>